import React from 'react';

const OrderedBadge = () => (
  <span className="px-2 py-0.5 rounded text-xs font-medium text-green-800 bg-green-100">
    Transferred
  </span>
);

export default OrderedBadge;
